import { createSlice } from "@reduxjs/toolkit";
import {
  getRoleById,
  getRoles,
  RolePermissions,
  updateRolePermissions,
} from "./_rolesAction";

interface RoleModule {
  key: string;
  label: string;
}

interface Role {
  _id: string;
  name: string;
  slug: string;
  isSystemDefined: boolean;
  permissions: RolePermissions;
  createdAt?: string;
  updatedAt?: string;
}

interface RolesState {
  roles: Role[];
  selectedRole: Role | null;
  modules: RoleModule[];
  permissionTypes: string[];
  isLoading: boolean;
  isSaving: boolean;
  isSuccess: boolean;
  responseMessage: string;
  errorMessage: string;
}

const initialState: RolesState = {
  roles: [],
  selectedRole: null,
  modules: [],
  permissionTypes: [],
  isLoading: false,
  isSaving: false,
  isSuccess: false,
  responseMessage: "",
  errorMessage: "",
};

export const rolesList = createSlice({
  name: "rolesList",
  initialState,
  reducers: {
    clearSelectedRole: (state) => {
      state.selectedRole = null;
      state.modules = [];
      state.permissionTypes = [];
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getRoles.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getRoles.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.roles = payload.data.roles || [];
        state.isSuccess = true;
        state.responseMessage = payload.responseMessage || "";
      })
      .addCase(getRoles.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.errorMessage = payload as string;
      })
      .addCase(getRoleById.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getRoleById.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.selectedRole = payload.data.role;
        state.modules = payload.data.modules || [];
        state.permissionTypes = payload.data.permissionTypes || [];
        state.isSuccess = true;
        state.responseMessage = payload.responseMessage || "";
      })
      .addCase(getRoleById.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.errorMessage = payload as string;
      })
      .addCase(updateRolePermissions.pending, (state) => {
        state.isSaving = true;
      })
      .addCase(updateRolePermissions.fulfilled, (state, { payload }) => {
        state.isSaving = false;
        state.selectedRole = payload.data.role;
        state.isSuccess = true;
        state.responseMessage = payload.responseMessage || "";
      })
      .addCase(updateRolePermissions.rejected, (state, { payload }) => {
        state.isSaving = false;
        state.errorMessage = payload as string;
      });
  },
});

export const { clearSelectedRole } = rolesList.actions;
